//import _ from 'lodash';
import { connect } from 'react-redux';
import {
	getMonthlySales,
	getTankDailySales,
	getNewStationsSalesAndRetail,
	getSlidingMonthComparison,
	addInventoryRecord,
	updateInventoryRecord,
	getTankDailyInventories,
	addDeliveryRecord,
	updateDeliveryRecord,
} from '../../modules/reports/monitoring';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => {
	let salesByMonth = {};
	let tankDailySales = undefined;
	let tankDailySalesPlus = undefined;
	let tankMonthlySales = undefined;
	let tankDailyInventories = undefined;
	let slidingMonthComparisonResult = undefined;

	if (state.reportsMonitoring.salesByMonth) {
		salesByMonth = state.reportsMonitoring.salesByMonth;
	}

	if (state.reportsMonitoring.tankDailySales) {
		tankDailySales = state.reportsMonitoring.tankDailySales;
	}

	if (state.reportsMonitoring.tankDailySalesPlus) {
		tankDailySalesPlus = state.reportsMonitoring.tankDailySalesPlus;
	}

	if (state.reportsMonitoring.tankMonthlySales) {
		tankMonthlySales = state.reportsMonitoring.tankMonthlySales;
	}

	if (state.reportsMonitoring.tankDailyInventories) {
		tankDailyInventories = state.reportsMonitoring.tankDailyInventories;
	}

	if (state.reportsMonitoring.slidingMonthComparisonResult) {
		slidingMonthComparisonResult = state.reportsMonitoring.slidingMonthComparisonResult;
	}

	return {
		salesByMonth,
		tankDailySales,
		tankDailySalesPlus,
		tankMonthlySales,
		tankDailyInventories,
		slidingMonthComparisonResult,
		stationMap: state.maps.station,
		gasFormulaMap: state.maps.gasFormula,
		rackFormulaMap: state.maps.rackFormula,
		userMap: state.maps.user,
		authUser: state.auth.authUser,
		accessToken: state.auth.accessToken, //- used on reporting page
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getMonthlySales,
			getTankDailySales,
			getNewStationsSalesAndRetail,
			getSlidingMonthComparison,
			getTankDailyInventories,
			addInventoryRecord,
			updateInventoryRecord,
			addDeliveryRecord,
			updateDeliveryRecord,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
